module.exports = __webpack_public_path__ + "img/首页证书4.aefe7d80.jpg";